export const APP_CARD = {
  "Card.Color": {
    ref: "Color.Gray.600"
  },
  "Card.Caption.Color": {
    ref: "Color.Gray.500"
  },
  "Card.Bg.Color": {
    ref: "Color.White"
  },
  "Card.Icon.Color": {
    ref: "Color.Black"
  },
  "Card.Icon.Background.Color": {
    defaultValue: "transparent"
  },
  "Card.Box.Shadow": {
    ref: "Shadow.100"
  },
  "Card.Border.Color": {
    defaultValue: "transparent"
  },

  "Card.Border.Top.Width": {
    defaultValue: "0"
  },
  "Card.Border.Right.Width": {
    defaultValue: "0"
  },
  "Card.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Card.Border.Left.Width": {
    defaultValue: "0"
  },
  "Card.Border.Top.Right.Radius": {
    defaultValue: "0"
  },
  "Card.Border.Bottom.Right.Radius": {
    defaultValue: "0"
  },
  "Card.Border.Bottom.Left.Radius": {
    defaultValue: "0"
  },
  "Card.Border.Top.Left.Radius": {
    defaultValue: "0"
  },
  "Card.Margin.Top": {
    defaultValue: "0"
  },
  "Card.Margin.Right": {
    defaultValue: "0"
  },
  "Card.Margin.Bottom": {
    defaultValue: "0"
  },
  "Card.Margin.Left": {
    defaultValue: "0"
  },
  "Card.Padding.Top": {
    defaultValue: "0"
  },
  "Card.Padding.Right": {
    defaultValue: "0"
  },
  "Card.Padding.Bottom": {
    defaultValue: "0"
  },
  "Card.Padding.Left": {
    defaultValue: "0"
  },
  "Card.Width": {
    defaultValue: "220px"
  },
  "Card.Height": {
    defaultValue: "auto"
  },
  "Card.Min.Height": {
    defaultValue: "unset"
  },
  "Card.Min.Width": {
    defaultValue: "0"
  },
  "Card.Max.Height": {
    defaultValue: "unset"
  },
  "Card.Max.Width": {
    defaultValue: "unset"
  }
};
